module.exports = __webpack_public_path__ + "3e1b8c7fa7ad6693daa896857d4d9bf1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/pirate-flag.png
// module id = 1639
// module chunks = 0